import type { BlockSerialized } from '#layers/block-engine';
import type { MonospaceBlock } from '#layers/data-model/types/schema/resolved-schema';
import { isObjectEmpty, pick } from '#layers/base/utils/object';

export function mapBlockDataToSerialized(block: MonospaceBlock): BlockSerialized {
	return {
		id: block.id,
		name: block.name,
		icon: block.icon,
		description: block.description,
		category: block.category,
		props: block.renderData?.props ?? null,
		events: block.renderData?.events ?? null,
		slots: block.renderData?.slots ?? null,
		variables: block.renderData?.variables ?? null,
		children: block.renderData?.children ?? null,
		rootChildren: block.renderData?.rootChildren ?? null,
	};
}

export function mapSerializedToBlockData(block: BlockSerialized): Omit<MonospaceBlock, 'spaceId' | 'pageId' | 'pageType' | 'pageIntent' | 'collectionId'> {
	const renderData = pick(block, ['props', 'events', 'slots', 'variables', 'children', 'rootChildren']);

	return {
		id: block.id,
		name: block.name,
		icon: block.icon ?? null,
		description: block.description ?? null,
		category: block.category ?? null,
		renderData: isObjectEmpty(renderData) ? null : renderData,
	};
}
